import { Box } from 'native-base';
import { Caption } from './Typography';
import React from 'react';
import { useTheme } from '@springbig/shared';

type ProgressProps = {
    progress: string | number;
    title?: string
};

const SimpleProgressBar = ({
    progress,
    title,
}: ProgressProps) => {

    const {
        button_primary,
    } = useTheme();

    return (
        <Box
            justifyContent={'space-between'}
            flexDirection={'column'}
            my={2}
            h={10}
        >
            {title && (
                <Caption whiteSpace={'nowrap'} w={'20%'} textAlign='left'>{title}</Caption>
            )}
            <Box
                position={'relative'}
                flex={1}
                borderRadius={'100vh'}
                borderColor={button_primary}
                borderWidth={0.25}
            >
                <Box
                    bg={button_primary}
                    h={'100%'}
                    left={0}
                    w={progress + '%'}
                    borderRadius={'100vh'}
                />
                <Caption
                    position={'absolute'}
                    top={0}
                    left={'50%'}
                >
                    {progress}%
                </Caption>
            </Box>
        </Box>
    );
};

export default SimpleProgressBar;
